'use client';

import dynamic from 'next/dynamic';

const ApplyNowBannerClient = dynamic(() => import('./ApplyNowBannerClient'), {
  ssr: false,
  loading: () => null,
});

export default function ApplyNowBannerWrapper() {
  return <ApplyNowBannerClient />;
}
